import type {QuizSessionDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import getQuizSessionCollection from './getQuizSessionCollection';

export function getQuizSessionDocRef(uid: string, sessionId: string): DocumentReference<QuizSessionDb> {
  return doc(getQuizSessionCollection(uid), sessionId);
}
